import React from 'react';
import { Container, Grid, Button } from '@material-ui/core';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { TitleText } from '../common/titleText';
import { MessageText } from '../common/messageText';
import { WeatherBugIcon } from '../common/icons/weatherBugIcon';

interface SignUpSuccessProps {
    returnUrl: string;
}
export const SignUpSuccess = ({ returnUrl }:SignUpSuccessProps) => {
    const { t } = useTranslation();
    const whereToGo = decodeURIComponent(returnUrl);

    return(
        <SignUpSuccessContainer>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TitleText>{t('welcomeToWeatherbug')}</TitleText>
                    <MessageText>{t('youAreNowSignedIn')}</MessageText>
                </Grid>
                <Grid item xs={12}>
                    <WelcomeMessageBox>
                        <HeaderContainer>
                            <OpeningSalutation>
                                {t('dearWeatherBugUsers')}
                            </OpeningSalutation>
                            <IconWrapper>
                                <WeatherBugIcon/>
                            </IconWrapper>
                        </HeaderContainer>
                        <TextContainer>
                            <WelcomeText>{t('enjoyTheSameWeatherBugExperience')}</WelcomeText>
                            <WelcomeText>{t('manageYourSettings')}</WelcomeText>
                            <WelcomeText>{t('synchronizeYourSavedLocations')}</WelcomeText>
                        </TextContainer>
                    </WelcomeMessageBox>
                </Grid>
                <Grid item xs={12}>
                    <StyledButton 
                        onClick={() => {window.location.assign(whereToGo);}}
                        fullWidth
                        variant='outlined'
                    >
                        { returnUrl ? t('ok') : t('signIn') } 
                    </StyledButton>
                </Grid>  
            </Grid>
        </SignUpSuccessContainer>
    );
};

const SignUpSuccessContainer = styled(Container)`
    margin-top: 50px;
`;

const StyledButton = styled(Button)`
    background-color: #0083C6;
    color: #ffffff;
`;

const WelcomeMessageBox = styled(Grid)`
    display: flex;
    flex-direction: column;
    padding: 16px 8px;
    height: 298px;
    background: rgba(0, 131, 198, 0.03);
`;

const HeaderContainer = styled(Grid)`
    display: flex;
    flex-direction: row;
    margin: 20px 0 0 20px;
`;

const OpeningSalutation = styled(Grid)`
    position: static;
    width: 155px;
    height: 102px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    color: #0083C6;
`;

const IconWrapper = styled.div`
    margin: 0 9% 0 auto;
`;

const TextContainer = styled.div`
    margin: auto 0 0 20px;
`;

const WelcomeText = styled.p`
    font-family: Roboto;
    font-size: 15px;
`;
